import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['toggle', 'toggleable', 'categorySelect']
  static values = {
    selectAll: String,
    unselectAll: String,
  }

  toggleSingle() {
    const anySelected = this.toggleableTargets.some(element => element.checked)

    if (anySelected) {
      this.categorySelectTarget.classList.remove('hidden')
    } else {
      this.categorySelectTarget.classList.add('hidden')
    }
  }

  toggleAll() {
    const allSelected = this.toggleableTargets.every(element => element.checked)
    this.toggleableTargets.forEach(element => element.checked = !allSelected)

    if (allSelected) {
      this.toggleTarget.textContent = this.selectAllValue
      this.categorySelectTarget.classList.add('hidden')
    } else {
      this.toggleTarget.textContent = this.unselectAllValue
      this.categorySelectTarget.classList.remove('hidden')
    }
  }

  batchUpdate(event) {
    const category = event.target.value
    const selectedIds = this.toggleableTargets
      .filter(element => element.checked)
      .map(element => element.dataset.id)

    if (!category || selectedIds.length === 0) return

    const formData = new FormData()
    formData.append('transaction[category]', category)
    selectedIds.forEach(id => {
      formData.append('transaction[transaction_ids][]', id)
    })
    fetch('/transactions/batch_update', {
      method: 'PATCH',
      headers: { 'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content },
      body: formData
    }).then(response => {
      if (response.redirected) {
        window.location.href = response.url
      }
    })
  }
}
